import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tomador.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.tomador.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.tomador.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.tomador.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.tomador.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    return serves.tomador.evento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        console.log(err);
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoLista = ({dispatch},payload)=>{
    return serves.tomador.eventolista(payload).then(res => {
        dispatch('ActionSetListaEvento',res)
    }).catch(err => {
        dispatch('ActionSetListaEvento',err)
    })
}
export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.tomador.eventocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoDeletaEsocial = ({dispatch},payload)=>{
    return serves.tomador.eventodeleteesocial(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoDeleta = ({dispatch},payload)=>{
    return serves.tomador.eventodelete(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoUpdate = ({dispatch},payload)=>{
    return serves.tomador.eventoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionListaDocumento = ({dispatch},payload)=>{
    return serves.tomador.documento(payload).then(res => {
        dispatch('ActionSetListaDocumento',res)
    }).catch(err => {
        dispatch('ActionSetListaDocumento',err)
    })
}
export const ActionMatricula = ({dispatch},payload)=>{
    return serves.tomador.matricula(payload).then(res => {
        dispatch('ActionSetMatricula',res)
    }).catch(err => {
        dispatch('ActionSetMatricula',err)
    })
}
export const ActionDuplica = ({dispatch},payload)=>{
    return serves.tomador.duplica(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetEvento = ({commit},payload) =>{
    commit(types.SET_EVENTO,payload)
}

export const ActionSetListaEvento = ({commit},payload) =>{
    commit(types.SET_LISTAEVENTO,payload)
}
export const ActionSetListaDocumento = ({commit},payload) =>{
    commit(types.SET_LISTADOCUMENTO,payload)
}
export const ActionSetMatricula = ({commit},payload) =>{
    commit(types.SET_MATRICULA,payload)
}
